import {Dispatch} from "redux";

import {IOfferDetailApplication} from "../../../offer/types/IOfferDetailApplication";
import {IPropertyDetailApplication} from "../../../property/types/IPropertyDetailApplication";
import {recommendationsDistanceInKm} from "../../constants/multi_lead_constants";
import {IApplication} from "../../types/IApplication";
import {getStorageSentApplicationsIdListByOffer} from "../get_storage_sent_applications_id_list_by_offer";
import {fetchLeadRecommendations} from "./fetch_lead_recommendations";

interface IGetSimpleMultiLeadRecommendationsParams {
    dispatch: Dispatch;
    sentApplication: IApplication | null;
    offer?: IOfferDetailApplication;
    property?: IPropertyDetailApplication;
    recommendedFilters?: Record<string, string>;
}

export async function fetchSimpleMultiLeadRecommendations(params: IGetSimpleMultiLeadRecommendationsParams) {
    const {sentApplication, offer, property, recommendedFilters, dispatch} = params;

    const excludedOfferIds = getStorageSentApplicationsIdListByOffer(offer, {limit: 50, distance: recommendationsDistanceInKm * 1000});

    // In case of NOT ADDING the radius to fetch payload, update FormSuccessInfoContainer tracking hit
    return fetchLeadRecommendations({
        dispatch,
        offerId: offer?.id,
        propertyId: property?.id,
        numberOfRooms: sentApplication?.rooms,
        excludedOfferIds,
        filters: {
            ...recommendedFilters,
            radius: recommendationsDistanceInKm.toString()
        }
    });
}
import {Dispatch} from "redux";

import {IOfferDetailApplication} from "../../../offer/types/IOfferDetailApplication";
import {IPropertyDetailApplication} from "../../../property/types/IPropertyDetailApplication";
import {recommendationsDistanceInKm} from "../../constants/multi_lead_constants";
import {IApplication} from "../../types/IApplication";
import {getStorageSentApplicationsIdListByOffer} from "../get_storage_sent_applications_id_list_by_offer";
import {fetchLeadRecommendations} from "./fetch_lead_recommendations";

interface IGetSimpleMultiLeadRecommendationsParams {
    dispatch: Dispatch;
    sentApplication: IApplication | null;
    offer?: IOfferDetailApplication;
    property?: IPropertyDetailApplication;
    recommendedFilters?: Record<string, string>;
}

export async function fetchSimpleMultiLeadRecommendations(params: IGetSimpleMultiLeadRecommendationsParams) {
    const {sentApplication, offer, property, recommendedFilters, dispatch} = params;

    const excludedOfferIds = getStorageSentApplicationsIdListByOffer(offer, {limit: 50, distance: recommendationsDistanceInKm * 1000});

    // In case of NOT ADDING the radius to fetch payload, update FormSuccessInfoContainer tracking hit
    return fetchLeadRecommendations({
        dispatch,
        offerId: offer?.id,
        propertyId: property?.id,
        numberOfRooms: sentApplication?.rooms,
        excludedOfferIds,
        filters: {
            ...recommendedFilters,
            radius: recommendationsDistanceInKm.toString()
        }
    });
}
